<div class="bg-gray-50 dark:bg-gray-900 p-4 sm:p-6 font-sans">
    <div class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 mb-6 shadow-sm">
        <form [formGroup]="filterForm" class="flex flex-col sm:flex-row flex-wrap items-center gap-4">
            <mat-form-field appearance="outline" class="flex-auto">
                <mat-label>User</mat-label>
                <mat-select formControlName="user">
                    <mat-option value="">All Users</mat-option>
                    <mat-option *ngFor="let user of uniqueUsers" [value]="user">{{ user }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="flex-auto">
                <mat-label>Search Summary</mat-label>
                <input matInput formControlName="keyword" placeholder="e.g., Name, Approved, etc.">
            </mat-form-field>

            <mat-form-field appearance="outline" class="flex-auto">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [formGroup]="filterForm.get('dateRange')!" [rangePicker]="picker">
                    <input matStartDate formControlName="start" placeholder="Start date">
                    <input matEndDate formControlName="end" placeholder="End date">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>

            <div class="flex items-center gap-2">
                <button mat-flat-button color="primary" type="button" (click)="applyFilters()">Filter</button>
                <button mat-button type="button" (click)="resetFilters()">Reset</button>
            </div>
        </form>
    </div>

    <div *ngIf="paginatedHistory.length > 0; else noResults">
        <div class="space-y-6">
            <div *ngFor="let entry of paginatedHistory" class="flex items-start gap-4">
                <div class="flex-shrink-0 w-10 h-10 rounded-full bg-indigo-500 text-white flex items-center justify-center font-bold text-sm" [title]="entry.ds_userchange">
                    {{ getInitials(entry.ds_userchange) }}
                </div>
                <div class="flex-grow bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-4">
                    <div class="flex flex-col sm:flex-row justify-between sm:items-center mb-2">
                        <p class="font-semibold text-gray-800 dark:text-gray-100">{{ entry.ds_userchange }}</p>
                        <p class="text-sm text-gray-500 dark:text-gray-400 mt-1 sm:mt-0" [title]="entry.dt_change.datetime.date | date:'full'">
                            {{ entry.dt_change.datetime.date | date:'medium' }}
                        </p>
                    </div>
                    <p class="text-sm text-gray-600 dark:text-gray-300 mb-3">The following was updated:</p>
                    <div class="flex flex-wrap gap-2">
                        <span *ngFor="let field of entry.changedFields" class="inline-block bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200 text-xs font-medium px-2.5 py-1 rounded-full">
                            {{ field }}
                        </span>
                    </div>

                    <ng-container *ngIf="entry.isReviewed; else pendingReview">
                        <div class="mt-4 pt-4 border-t border-gray-200 dark:border-gray-600">
                            <div class="flex items-center gap-2 mb-2">
                                <mat-icon class="text-green-500 !w-5 !h-5">check_circle</mat-icon>
                                <p class="text-sm font-semibold text-gray-700 dark:text-gray-200">{{ entry.reviewSummary }}</p>
                                <p class="text-xs text-gray-500 dark:text-gray-400 ml-auto" *ngIf="entry.reviewDate" [title]="entry.reviewDate | date:'full'">
                                    {{ entry.reviewDate | date:'mediumDate' }}
                                </p>
                            </div>
                            <div *ngIf="entry.reviewComment" class="pl-7 text-sm">
                                <blockquote class="bg-gray-50 dark:bg-gray-700/50 p-3 rounded-md border-l-4 border-green-500 text-gray-600 dark:text-gray-300">
                                    <p class="italic">"{{ entry.reviewComment }}"</p>
                                </blockquote>
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #pendingReview>
                        <div class="mt-4 pt-4 border-t border-gray-200 dark:border-gray-600">
                            <div class="flex items-center gap-2">
                                <mat-icon class="text-yellow-500 !w-5 !h-5">hourglass_empty</mat-icon>
                                <p class="text-sm font-medium text-yellow-800 dark:text-yellow-300">Pending Review</p>
                            </div>
                        </div>
                    </ng-template>

                </div>
            </div>
        </div>

        <mat-paginator
            *ngIf="filteredHistory.length > 10"
            class="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-6 rounded-lg shadow-sm"
            [length]="filteredHistory.length"
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 20, 50]"
            [showFirstLastButtons]="true">
        </mat-paginator>

    </div>

    <ng-template #noResults>
        <div class="text-center text-gray-500 dark:text-gray-400 py-16 px-6 italic bg-white dark:bg-gray-800 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg">
            <p>No history found for the selected criteria.</p>
        </div>
    </ng-template>
</div>
